import { lazy } from 'react';

export const SettingsRoutes = {
  AccessControl: lazy(() =>
    import('@/modules/Settings/pages/AccessControl').then(({ AccessControl }) => ({
      default: AccessControl,
    })),
  ),

  Actions: lazy(() =>
    import('@/modules/Settings/pages/Actions').then(({ Actions }) => ({
      default: Actions,
    })),
  ),

  AutoApproval: lazy(() =>
    import('@/modules/Settings/pages/AutoApproval').then(({ AutoApproval }) => ({
      default: AutoApproval,
    })),
  ),

  Profile: lazy(() =>
    import('@/modules/Settings/pages/Profile').then(({ Profile }) => ({
      default: Profile,
    })),
  ),

  Settings: lazy(() =>
    import('@/modules/Settings/pages/Settings').then(({ Settings }) => ({
      default: Settings,
    })),
  ),

  SiteHours: lazy(() =>
    import('@/modules/Settings/pages/SiteHours').then(({ SiteHours }) => ({
      default: SiteHours,
    })),
  ),

  SiteMap: lazy(() =>
    import('@/modules/Settings/pages/SiteMap').then(({ SiteMap }) => ({
      default: SiteMap,
    })),
  ),

  System: lazy(() =>
    import('@/modules/Settings/pages/System').then(({ System }) => ({
      default: System,
    })),
  ),

  ZPSAccess: lazy(() =>
    import('@/modules/Settings/pages/ZPSAccess').then(({ ZPSAccess }) => ({
      default: ZPSAccess,
    })),
  ),
  DeviceManagement: lazy(() =>
    import('@/modules/Settings/pages/DeviceManagement').then(({ DeviceManagement }) => ({
      default: DeviceManagement,
    })),
  ),

  Tags: lazy(() =>
    import('@/modules/Settings/pages/DeviceManagement/Tags/Tags').then(({ Tags }) => ({
      default: Tags,
    })),
  ),
  Readers: lazy(() =>
    import('@/modules/Settings/pages/DeviceManagement/Readers/Readers').then(({ Readers }) => ({
      default: Readers,
    })),
  ),
  Hubs: lazy(() =>
    import('@/modules/Settings/pages/DeviceManagement/Hubs/Hubs').then(({ Hubs }) => ({
      default: Hubs,
    })),
  ),
  Devices5G: lazy(() =>
    import('@/modules/Settings/pages/DeviceManagement/Devices5G/Devices5G').then(
      ({ Devices5G }) => ({
        default: Devices5G,
      }),
    ),
  ),
  SiteManagement: lazy(() =>
    import('@/modules/Settings/pages/SiteManagementProxy/SiteManagementProxy').then(({ SiteManagementProxy }) => ({
      default: SiteManagementProxy,
    })),
  ),
};
